// @ts-strict-ignore
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { InAppPurchaseWebPrice, MediaItem, RedeemCode } from 'mytours-read-api-typescript'
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import LockAppComponent from '../components/LockApp'

interface Props {
	title: string
	description: string
	backgroundImage: MediaItem
	linkedId?: number
	linkedType?: RedeemCode.LinkedTypeEnum
	webPrice?: InAppPurchaseWebPrice
}

const LockAppRoute: FC<RouteComponentProps & Props> = ({
	title,
	description,
	backgroundImage,
	linkedId,
	linkedType,
	webPrice,
}) => (
	<LockAppComponent
		title={title}
		description={description}
		backgroundImage={backgroundImage}
		linkedId={linkedId}
		linkedType={linkedType}
		webPrice={webPrice}
	/>
)

export default WithContainerRoute(LockAppRoute)
